import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import './AdminVentas.css'; // Importamos el CSS

// 🔧 CORREGIDO: API_URL incluye /api
const API_URL = process.env.REACT_APP_API_URL || 'https://api.romanvalderrabanoelcatador.com/api';

const AdminVentas = () => {
  const [ventas, setVentas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('pendiente'); // pendiente, pagado, rechazado, todas

  useEffect(() => {
    cargarVentas();
  }, []);

  const cargarVentas = async () => {
    try {
      setLoading(true);
      const res = await api.get('/ventas');
      setVentas(res.data);
    } catch (error) {
      console.warn('Error cargando ventas, usando datos de prueba (Mock):', error);
      // Red de seguridad: Datos de prueba si el backend falla
      const mockVentas = [
        { id: 1, folio: 'VNT-00102', cliente_nombre: 'Empresa Cafetalera SA', total: 4500.00, metodo_pago: 'transferencia', estatus: 'pendiente', comprobante_url: '/uploads/comp_1.jpg', created_at: '2026-05-13T10:30:00Z' },
        { id: 2, folio: 'VNT-00103', cliente_nombre: 'Restaurante El Portal', total: 1250.50, metodo_pago: 'tarjeta', estatus: 'pagado', comprobante_url: 'https://ejemplo.com/stripe-receipt', created_at: '2026-05-12T15:45:00Z' },
        { id: 3, folio: 'VNT-00104', cliente_nombre: 'Luis Osorio', total: 850.00, metodo_pago: 'transferencia', estatus: 'pendiente', comprobante_url: null, created_at: '2026-05-13T11:00:00Z' },
        { id: 4, folio: 'VNT-00105', cliente_nombre: 'Cafetería Central', total: 3200.00, metodo_pago: 'transferencia', estatus: 'rechazado', comprobante_url: '/uploads/comp_bad.jpg', created_at: '2026-05-10T09:15:00Z' }
      ];
      setVentas(mockVentas);
    } finally {
      setLoading(false);
    }
  };

  const aprobarPago = async (id) => {
    if (!window.confirm('✅ ¿Estás seguro de APROBAR este pago? El pedido pasará a preparación.')) return;
    try {
      // Actualización visual instantánea
      setVentas(ventas.map(v => v.id === id ? { ...v, estatus: 'pagado' } : v));
      await api.put(`/ventas/${id}/aprobar`);
    } catch (error) {
      console.error('Error al aprobar la API:', error);
    }
  };

  const rechazarPago = async (id) => {
    if (!window.confirm('❌ ¿Estás seguro de RECHAZAR este pago? Se notificará al cliente.')) return;
    try {
      // Actualización visual instantánea
      setVentas(ventas.map(v => v.id === id ? { ...v, estatus: 'rechazado' } : v));
      await api.put(`/ventas/${id}/rechazar`);
    } catch (error) {
      console.error('Error al rechazar la API:', error);
    }
  };

  // 🔧 FUNCIÓN CORREGIDA: Obtener URL completa del comprobante
  const getComprobanteUrl = (url) => {
    if (!url) return null;
    if (url.startsWith('http')) return url;
    return `${API_URL}${url}`;
  };

  const formatearMoneda = (cantidad) => {
    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(cantidad);
  };

  const formatearFecha = (fecha) => {
    if(!fecha) return 'N/A';
    return new Date(fecha).toLocaleDateString('es-MX', {
        day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
    });
  };

  const ventasFiltradas = filtro === 'todas' 
    ? ventas 
    : ventas.filter(v => v.estatus === filtro);

  if (loading) {
    return (
        <div className="admin-loading-screen">
            <div className="coffee-spinner">☕</div>
            <p>Cargando registros de ventas...</p>
        </div>
    );
  }

  return (
    <div className="admin-page-container">
      <div className="admin-header-flex">
        <div>
          <h1>💰 Control de Ventas e Ingresos</h1>
          <p>Valida los comprobantes de pago para liberar los envíos o entregas</p>
        </div>
      </div>

      <div className="filtros-card">
        <div className="filtros-group">
          <button className={`filtro-btn ${filtro === 'todas' ? 'active' : ''}`} onClick={() => setFiltro('todas')}>Todas</button>
          <button className={`filtro-btn ${filtro === 'pendiente' ? 'active' : ''}`} onClick={() => setFiltro('pendiente')}>Pendientes</button>
          <button className={`filtro-btn ${filtro === 'pagado' ? 'active' : ''}`} onClick={() => setFiltro('pagado')}>Pagadas</button>
          <button className={`filtro-btn ${filtro === 'rechazado' ? 'active' : ''}`} onClick={() => setFiltro('rechazado')}>Rechazadas</button>
        </div>
      </div>

      <div className="table-wrapper">
        <table className="admin-table ventas-table">
          <thead>
            <tr>
              <th>Folio / Fecha</th>
              <th>Cliente</th>
              <th>Total</th>
              <th>Método</th>
              <th>Comprobante</th>
              <th>Estatus</th>
              <th className="text-right">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {ventasFiltradas.length === 0 && (
              <tr>
                <td colSpan="7" className="empty-state">
                  No hay ventas registradas con el estatus "{filtro}".
                </td>
              </tr>
            )}
            
            {ventasFiltradas.map(v => {
              const comprobanteUrl = getComprobanteUrl(v.comprobante_url);
              return (
                <tr key={v.id}>
                  <td>
                    <span className="folio-badge">{v.folio}</span><br/>
                    <small className="fecha-text">{formatearFecha(v.created_at)}</small>
                  </td>
                  <td><strong>{v.cliente_nombre}</strong></td>
                  <td className="fw-bold" style={{color: '#2E7D32'}}>{formatearMoneda(v.total)}</td>
                  <td>
                    <span className={`metodo-pago ${v.metodo_pago}`}>
                      {v.metodo_pago === 'transferencia' ? '🏦 Transferencia' : '💳 Tarjeta'}
                    </span>
                  </td>
                  <td>
                    {comprobanteUrl ? (
                      <a href={comprobanteUrl} target="_blank" rel="noopener noreferrer" className="btn-comprobante">
                        📄 Ver Archivo
                      </a>
                    ) : (
                      <span className="sin-comprobante">⏳ Esperando...</span>
                    )}
                  </td>
                  <td>
                    <span className={`status-pill ${v.estatus}`}>
                      {v.estatus}
                    </span>
                  </td>
                  <td>
                    <div className="acciones-flex">
                      <button className="btn-icon-action info" title="Ver detalles del pedido">
                        👁️
                      </button>
                      
                      {v.estatus === 'pendiente' && (
                        <>
                          <button 
                            className="btn-icon-action success" 
                            onClick={() => aprobarPago(v.id)} 
                            title="Aprobar pago"
                          >
                            ✅
                          </button>
                          <button 
                            className="btn-icon-action danger" 
                            onClick={() => rechazarPago(v.id)} 
                            title="Rechazar pago"
                          >
                            ❌
                          </button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminVentas;